import styled, { css } from 'styled-components';

export const GlobalErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 16px;
  width: 100%;
  min-height: 600px;
`;

export const DangerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  width: 100%;
  padding: 32px; 
  border-radius: 8px;
`;

export const IconWrapper = styled.div`
  margin-bottom: 24px;
  opacity: 0.9;
`;

export const Title = styled.h2`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.7;
  margin: 0 0 8px 0;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};
  text-align: center;
`;

export const ErrorCodeBadge = styled.div`
  display: inline-flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  padding: 8px 0;
  color: #ef4444;
  font-size: 18px;
  font-weight: 500;
  border-radius: 6px;
  letter-spacing: 0.5px;
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 24px 0;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  text-align: center;
  max-width: 800px;
`;

export const ErrorDetailsContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin-bottom: 24px;
`;

export const ErrorDetails = styled.details`
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1f2937' : '#f9fafb')};
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  cursor: pointer;

  &[open] {
    padding-bottom: 16px;
  }
`;

export const ErrorSummary = styled.summary`
  font-size: 12px;
  font-weight: 400;
  text-decoration: underline;
  text-underline-offset: 3px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
  cursor: pointer;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 8px;

  &::-webkit-details-marker {
    display: none;
  }

  &::before {
    content: '▶';
    display: inline-block;
    transition: transform 0.2s ease;
  }

  ${ErrorDetails}[open] &::before {
    transform: rotate(90deg);
  }
`;

export const ErrorContent = styled.pre`
  margin: 6px 0 0 0;
  padding: 6px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#111827' : '#ffffff')};
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
  border-radius: 2px;
  font-size: 12px;
  line-height: 1.5;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#374151')};
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', 'Consolas', 'source-code-pro', monospace;
  max-height: 300px;
  overflow: auto;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

// Akcje na ekranie błędu to DROBNE LINKI, nie kolorowe przyciski. Duży czerwony
// przycisk sugerował, że użytkownik może coś naprawić — a realnie ma tylko
// spróbować ponownie, wrócić na stronę główną albo zgłosić problem.
const linkAction = css`
  padding: 4px 2px;
  font-size: 13px;
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.2s ease;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    text-decoration: none;
  }
`;

export const PrimaryButton = styled.button`
  ${linkAction};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};

  &:hover:not(:disabled) {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#ffffff' : '#000000')};
  }
`;

export const SecondaryButton = styled.button`
  ${linkAction};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};

  &:hover:not(:disabled) {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#111827')};
  }
`;

export const ReportButton = styled.button`
  ${linkAction};
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};

  &:hover:not(:disabled) {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#111827')};
  }
`;

export const ReportStatus = styled.p<{ $variant: 'success' | 'error' }>`
  font-size: 13px;
  margin: 12px 0 0 0;
  width: 100%;
  text-align: center;
  color: ${({ $variant }) => ($variant === 'success' ? '#16a34a' : '#ef4444')};
`;
